import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const LEGACY_CATEGORY = 'Data HistoricalLocationsToggle';

const HISTORIC_LOCATIONS_EVENT_NAMES = {
  TOGGLE_ON_TO_OFF: 'map_historic_locations_toggle_on_to_off',
  TOGGLE_OFF_TO_ON: 'map_historic_locations_toggle_off_to_on',
};

export const trackHistoricToggle = (
  showHistoricLocations: boolean,
  irpVersion?: unknown,
) => {
  if (showHistoricLocations) {
    gspx.trackEvent({
      name: HISTORIC_LOCATIONS_EVENT_NAMES.TOGGLE_ON_TO_OFF,
      type: GPX_EVENT_TYPES.INFO,
      feature: GPX_FEATURES.LEGACY,
      capability: GPX_CAPABILITIES.LEGACY,
      route: GPX_ROUTES.MAP,
      additionalKeys: {
        legacy_category: LEGACY_CATEGORY,
        legacy_name: 'Toggle historic locations on to off',
        Category: 'Google Map',
        'Launched date': new Date(),
        irpVersion,
      },
    });
  } else {
    gspx.trackEvent({
      name: HISTORIC_LOCATIONS_EVENT_NAMES.TOGGLE_OFF_TO_ON,
      type: GPX_EVENT_TYPES.INFO,
      feature: GPX_FEATURES.LEGACY,
      capability: GPX_CAPABILITIES.LEGACY,
      route: GPX_ROUTES.MAP,
      additionalKeys: {
        legacy_category: LEGACY_CATEGORY,
        legacy_name: 'Toggle historic locations off to on',
        Category: 'Google Map',
        'Launched date': new Date(),
        irpVersion,
      },
    });
  }
};
